<template>
	<div v-if="commandBarShortcut" class="try-your-tool-container on-boarding-step-explanation-text">
		<div class="mb-2 heavy">Try the tool you installed</div>
		<div class="display-flex flex-row flex-align-center">
			<div class="mr-1">First,</div>
			<div class="mr-1 purple-text">select the Welsh text below.</div>
			<div class="mr-1">Then, while it’s selected, open the command bar by</div>
			<div class="mr-1 purple-text">pressing</div>
			<div class="mr-1 purple-text box flex-centerize flex-row px-1">{{ commandBarShortcut }}</div>
			<div>to translate it</div>
		</div>
		<input
			@click="selectText"
			class="mt-3 text-to-translate-container flex-align-center display-flex"
			value="Cawsoch hwn. Gyda Ply gallwch chi adeiladu unrhyw nodwedd ar gyfer eich llinell orchymyn."
		/>
	</div>
	<div v-else class="display-flex flex-column">
		<h3 class="reg mb-1">First, setup your Command bar shortcut</h3>
		<AnemicButton @click="editShortcut" tile class="edit-button"> Set your shortcut </AnemicButton>
	</div>
</template>

<script>
const FLOW_RUN_DONE_EVENT = 'flowRunDone';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'OnBoardingGetToKnowRunTool',
	props: {
		subStepDetails: { type: Object },
		commandBarShortcut: { type: String },
		commandBarExampleInstallableId: { type: String },
	},
	components: {},
	computed: {
		isCompleted() {
			return this.subStepDetails.isCompleted;
		},
	},
	methods: {
		selectText(e) {
			e.target?.select();
		},
		markAsComplete() {
			this.$emit('mark-step-as-done', this.subStepDetails);
		},
		isDoneWorkflowTheExampleCommandBarWorkflow(workflow) {
			return workflow.installed_from === this.commandBarExampleInstallableId;
		},
		editShortcut() {
			AppDialogManagerService.openEditCommandBarShortcutDialog();
		},
	},
	created() {
		document.body.addEventListener(FLOW_RUN_DONE_EVENT, ({ detail: { workflow } }) => {
			if (this.isDoneWorkflowTheExampleCommandBarWorkflow(workflow)) {
				this.markAsComplete();
			}
		});
	},

	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.heavy {
	font-weight: 600 !important;
}
.try-your-tool-container {
	border-radius: 11px;
	background: #5f60dc05;
	border: 1px solid #5f60dc;
	padding: 21px 23px 12px 23px;
}
.purple-text {
	color: #5f60dc !important;
	font-weight: 600 !important;
}
.box {
	height: 24px;
	border-radius: 5px;
	background: #ffffff;
	border: 1px solid #5f60dc;
}
.text-to-translate-container {
	width: 100%;
	max-width: 760px;
	height: 45px;
	opacity: 0.7;
	font-size: 14px;
	color: #262626;
	padding-left: 10px;
	border-radius: 10px;
	background: #ffffff;
	border: 1px solid #dfdfe2;
}
.edit-button {
	height: 30px !important;
	width: 160px !important;
	font-size: 14px !important;
	color: #5858ec !important;
	border: 1px solid #5858ec;
	padding: 0px 10px !important;
	border-radius: 11px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: white !important;
}
</style>
